module.exports = __webpack_public_path__ + "img/bg_4@2x.2f57e05a.png";